interface Props {
  categories: { slug: string; name: string }[];
  value: string;
  onChange: (slug: string) => void;
}

/** Category buttons above the rail. Order and names come from Products → Categories in WooCommerce. */
export function CategoryChips({ categories, value, onChange }: Props) {
  if (categories.length < 2) return null;
  return (
    <div className="cats" role="group" aria-label="Category">
      {categories.map((c) => (
        <button key={c.slug} aria-pressed={c.slug === value} onClick={() => onChange(c.slug)}>{c.name}</button>
      ))}
    </div>
  );
}
